module.exports = __webpack_public_path__ + "static_pc/img/user.3b8daf82.png";